var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.039,
    height: 39.46,
    viewBox: "0 0 41.039 39.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chats-fill-svgrepo-com",
    d: "M65.039,44.628a3.16,3.16,0,0,0-3.157-3.157H55.569V35.157A3.16,3.16,0,0,0,52.412,32H27.157A3.16,3.16,0,0,0,24,35.157V60.412a1.578,1.578,0,0,0,2.571,1.227l6.9-5.578v5.929a3.16,3.16,0,0,0,3.157,3.157H55.093l7.376,5.963a1.578,1.578,0,0,0,2.571-1.227Zm-8.4,17.714a1.578,1.578,0,0,0-.992-.351H36.628V55.677H52.412a3.16,3.16,0,0,0,3.157-3.157V44.628h6.314V66.577Z",
    transform: "translate(-24 -32)",
    fill: "#d6c1a5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/Chats.8755a39a7299243b178d08df549b38cc.svg";
export { ForwardRef as ReactComponent };